import { AaaGameConceptData, IdXboxGameConceptData } from "../../models/forms";
import { GameConceptState } from "../../server/crm/api/models/forms";
import { ProgramsScope } from "../scopes";
import { createOnboardingAction } from "./helpers/actionCreators";

export enum GameConceptActions {
  UPDATE_SINGLE_IDXBOX_GAME_CONCEPT = "@status/UPDATE_SINGLE_IDXBOX_GAME_CONCEPT",
  CLEAR_SELECTED_IDXBOX_GAME_CONCEPT = "@status/CLEAR_SELECTED_IDXBOX_GAME_CONCEPT",
  UPDATE_SINGLE_AAA_GAME_CONCEPT = "@status/UPDATE_SINGLE_AAA_GAME_CONCEPT",
  CLEAR_SELECTED_AAA_GAME_CONCEPT = "@status/CLEAR_SELECTED_AAA_GAME_CONCEPT",
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const gameConceptActions: any = {
  updateSingleIdXboxGameConcept: createOnboardingAction(
    GameConceptActions.UPDATE_SINGLE_IDXBOX_GAME_CONCEPT,
    ProgramsScope,
    (gameConcept: IdXboxGameConceptData & GameConceptState) => ({
      gameConcept,
    })
  ),
  clearSelectedIdXboxGameConcept: createOnboardingAction(
    GameConceptActions.CLEAR_SELECTED_IDXBOX_GAME_CONCEPT,
    ProgramsScope,
    () => ({})
  ),
  updateSingleAaaGameConcept: createOnboardingAction(
    GameConceptActions.UPDATE_SINGLE_AAA_GAME_CONCEPT,
    ProgramsScope,
    (gameConcept: AaaGameConceptData & GameConceptState) => ({
      gameConcept,
    })
  ),
  clearSelectedAaaGameConcept: createOnboardingAction(
    GameConceptActions.CLEAR_SELECTED_AAA_GAME_CONCEPT,
    ProgramsScope,
    () => ({})
  ),
};
